"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateTranscribeAudioResult = void 0;
const validation_1 = require("@fmtk/validation");
exports.validateTranscribeAudioResult = (0, validation_1.properties)({
    message: (0, validation_1.text)(),
    code: (0, validation_1.integer)(),
});
//# sourceMappingURL=TranscribeAudioResult.js.map